module.exports = __webpack_public_path__ + "static/img/pat.m.1b6e713.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pat.m.jpg
// module id = 280
// module chunks = 358